/**
 * Severity Constants
 *
 * Severity level mappings and configurations for vulnerability risk assessment.
 * Extracted from VulnerabilityDrawer.tsx to centralize severity definitions.
 */

import { TagSeverity } from '@/components/chariot-ui';
import { RiskSeverity, SeverityDef } from '@/types';

/**
 * Mapping of risk severity codes to tag severity display types
 */
export const SEVERITY_TAG_MAP: Record<RiskSeverity, TagSeverity> = {
  C: 'critical',
  H: 'high',
  M: 'medium',
  L: 'low',
  I: 'info',
  E: 'exposure',
};

/**
 * Severity filter options for dropdown menus (from VulnerabilityDrawer)
 */
export const SEVERITY_DROPDOWN_FILTERS = [
  {
    label: SeverityDef[RiskSeverity.Critical],
    value: 'C',
    severity: 'critical' as TagSeverity,
  },
  {
    label: SeverityDef[RiskSeverity.High],
    value: 'H',
    severity: 'high' as TagSeverity,
  },
  {
    label: SeverityDef[RiskSeverity.Medium],
    value: 'M',
    severity: 'medium' as TagSeverity,
  },
  {
    label: SeverityDef[RiskSeverity.Low],
    value: 'L',
    severity: 'low' as TagSeverity,
  },
  {
    label: SeverityDef[RiskSeverity.Info],
    value: 'I',
    severity: 'info' as TagSeverity,
  },
  {
    label: SeverityDef[RiskSeverity.Exposure],
    value: RiskSeverity.Exposure,
    severity: 'exposure' as TagSeverity,
  },
];
